import React from 'react';
import auth from './app-auth';
import { actions as companyActions } from './app-dux/company-dux';

import loadHome from 'bundle-loader?lazy&title=Home!./components/routes/home';
import loadProgramList from 'bundle-loader?lazy&title=Programs!./components/routes/program-list';
import loadProgram from 'bundle-loader?lazy&title=Program!./components/routes/program';
import loadAwardFileList from 'bundle-loader?lazy&title=Programs!./components/routes/award-file-list';
import loadAwardFile from 'bundle-loader?lazy&title=Award File!./components/routes/award-file';
import loadRecipientList from 'bundle-loader?lazy&title=Programs!./components/routes/recipient-list';
import loadRecipientDetail from 'bundle-loader?lazy&title=Programs!./components/routes/recipient-detail';
import loadReports from 'bundle-loader?lazy&title=Reports!./components/routes/reports';
import loadHealth from 'bundle-loader?lazy&title=Health!./components/routes/health';
import loadSettings from 'bundle-loader?lazy&title=Settings!./components/routes/settings';
import loadTranslationsList from 'bundle-loader?lazy&title=Translations!./components/routes/translation/translationlist';
import loadTranslationsDetails from 'bundle-loader?lazy&title=Translation Details!./components/routes/translation/details';

const Bundle = ( Component ) => (
    ( props ) => (
        <Component { ...props } />
    )
);

export const routes = [ {
    title: 'Recipients',
    pattern: '/:companyId/programs/:programId/recipients',
    load: loadRecipientList
}, {
    title: 'Recipient Detail',
    pattern: '/:companyId/programs/:programId/recipient/:recipientId',
    load: loadRecipientDetail
}, {
    title: 'Award Files',
    pattern: '/:companyId/programs/:programId/award-files',
    load: loadAwardFileList
}, {
    title: 'Award File Load',
    pattern: '/:companyId/programs/:programId/award-files/:awardFileId/:step?',
    load: loadAwardFile
}, {
    title: 'Translations',
    pattern: '/:companyId/programs/:programId/translations',
    load: loadTranslationsList
}, {
    title: 'Details',
    pattern: '/:companyId/programs/:programId/translations/string/:keyName',
    load: loadTranslationsDetails
}, {
    title: 'Program',
    pattern: '/:companyId/program/:step?',
    load: loadProgram
}, {
    title: 'Program',
    pattern: '/:companyId/programs/:programId/:step?',
    load: loadProgram
}, {
    title: 'Service Awards',
    pattern: '/:companyId/programs',
    load: loadProgramList
}, {
    title: 'Service Awards',
    pattern: '/',
    load: loadHome
}, {
    title: 'Service Awards',
    pattern: '/:companyId/reports',
    load: loadReports
}, {
    title: 'Service Awards',
    pattern: '/health',
    load: loadHealth
}, {
    title: 'Service Awards',
    pattern: '/:companyId/health',
    load: loadHealth
}, {
    title: 'Company Settings',
    pattern: '/:companyId/settings',
    load: loadSettings
} ];

export const getMiddleware = ( store ) => {
    return [
        // Company
        ( action, nextRoute, prevRoute ) => {
            // we aren't signed in yet, so continue
            if ( !auth.state.access_token ) {
                return action.ok();
            }

            const nextCompanyId = nextRoute?.state?.params?.companyId;
            // if the next companyId is the same as the last companyId, continue
            if ( nextCompanyId === auth.state.company_id ) {
                return action.ok();
            }

            // switch to the new company
            store.dispatch(
                companyActions.setCompany( nextRoute.state.params.companyId )
            ).then( () => {
                action.ok();
            } );
        },

        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            if ( nextRoute.match && !nextRoute.match.render &&
                typeof nextRoute.match.load === 'function' ) {

                nextRoute.match.load( ( asyncModule ) => {
                    nextRoute.match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                    action.ok();
                } );
            } else {
                action.ok();
            }
        }
    ];
};
